import { EventEmitter, Injectable } from '@angular/core';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { WorkSpacesService } from '../workspaces/workspaces.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SharedVaultService {
  private API_SHARED_VAULT_URL = 'api/vault/vault';
  constructor(private readonly httpService: AmplifyHttpClient, private router: Router, private WorkSpacesService: WorkSpacesService) {}

  public getNoteMessage: EventEmitter<any> = new EventEmitter();
  getVaults(vaultUserId, isDispatchedAction: boolean = true, isLoader: boolean = true): Observable<any> {
    const parseUrl = this.router.url.split('/');
    if (parseUrl?.length > 2 && this.router.url.includes('workspace') && isDispatchedAction) {
      return this.WorkSpacesService.getWorkSpacesVaults(parseUrl[2]);
    } else {
      return this.httpService
        .get<any>(`${this.API_SHARED_VAULT_URL}/${vaultUserId}`, null, isLoader ? loaderTypes.mainAnimation : loaderTypes.none)
        .pipe(
          map((response: any) => {
            if (response.status === 200) {
              return response.data;
            } else {
              return response;
            }
          })
        );
    }
  }

  sendNoteCompletionMessage(data: any) {
    this.getNoteMessage.emit(data);
  }

  createVault(request, isNotAllowLoader = false): Observable<any> {
    request = {
      ...request,
      url: this.router.url,
    };
    return this.httpService.post<any>(`${this.API_SHARED_VAULT_URL}`, request, !isNotAllowLoader ? loaderTypes.mainAnimation : loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateVaultName(request): Observable<any> {
    return this.httpService.patch<any>(`${this.API_SHARED_VAULT_URL}`, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getVaultMembers(vaultUserId, vaultId): Observable<any> {
    return this.httpService.get<any>(`${this.API_SHARED_VAULT_URL}-member/${vaultUserId}/${vaultId}`, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  updateVaultOwner(request): Observable<any> {
    return this.httpService.patch<any>(`api/vault/vault-update-owner`, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  createVaultMember(request): Observable<any> {
    return this.httpService.post<any>(`${this.API_SHARED_VAULT_URL}-member`, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createPersonalVaultMember(request): Observable<any> {
    const url = 'api/vault/create-personal-vault-member';
    return this.httpService.post<any>(`${url}`, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteVaultMember(vaultUserId, vaultId): Observable<any> {
    return this.httpService.delete<any>(`${this.API_SHARED_VAULT_URL}-member/${vaultUserId}/${vaultId}`).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteVaultForever(userId, vaultId): Observable<any> {
    return this.httpService.delete<any>(`${this.API_SHARED_VAULT_URL}/${userId}/${vaultId}`).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }
  createSharedVault(request: data): Observable<any> {
    return this.httpService.post<any>(`api/vault/shared-vault-for-relationship`, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getVaultSetupFormTag(vaultUserId, vaultId): Observable<any> {
    return this.httpService.get<any>(`${this.API_SHARED_VAULT_URL}-user-form-tag/${vaultUserId}/${vaultId}`, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getVaultDuplicateForms(): Observable<any> {
    return this.httpService.get<any>(`api/vault/duplicate-forms`, null, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getNonVaultForms(origin, workSpaceId): Observable<any> {
    let url = `api/vault/non-vault-forms/${origin}`;
    if (workSpaceId) url += `?w_id=${workSpaceId}`;
    return this.httpService.get<any>(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getNonVaultPermissionData(vault_user_form_id): Observable<any> {
    return this.httpService.get<any>(`api/vault/vault-user-form-owner/${vault_user_form_id}`, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getVaultRegisterMembers(register_type): Observable<any> {
    return this.httpService.get<any>(`api/vault/vault-register-member/${register_type}`, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  postNonVaultPermissionData(request): Observable<any> {
    return this.httpService.post<any>(`api/vault/vault-user-form-owner`, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  saveVaultRegisterMember(request): Observable<any> {
    return this.httpService.post<any>(`api/vault/vault-register-member`, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateVaultRegisterMember(request, id): Observable<any> {
    return this.httpService.patch<any>(`api/vault/vault-register-member/${id}`, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteNonVaultPermissionData(vault_user_form_id, user_id): Observable<any> {
    return this.httpService.delete<any>(`api/vault/vault-user-form-owner/${vault_user_form_id}/${user_id}`).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  removeVaultRegisterMember(id): Observable<any> {
    return this.httpService.delete<any>(`api/vault/vault-register-member/${id}`).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  moveAttachmentFileItem(request: { id: number; user_id: string; vault_user_form_id: string }): Observable<any> {
    return this.httpService.post<any>(`api/vault/move-attachment-file-item`, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  duplicateAttachmentFileItem(request: { id: number; user_id: string; vault_user_form_id: string }): Observable<any> {
    return this.httpService.post<any>(`api/vault/duplicate-attachment-file-item`, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  // Vault User Form Document Suggestion Methods
  createVaultUserFormDocumentSuggestion( body: any): Observable<any> {
    return this.httpService.post<any>(`api/vault/vault-user-form-document-suggestion`, body, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateVaultUserFormDocumentSuggestion(payload: any): Observable<any> {
    return this.httpService.patch<any>(`api/vault/vault-user-form-document-suggestion`, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteVaultUserFormDocumentSuggestion(payload: any): Observable<any> {
    return this.httpService.post<any>(`api/vault/vault-user-form-document-suggestion-delete`, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getVaultUserFormDocumentSuggestion(userId: string, formId: string): Observable<any> {
    return this.httpService.get<any>(`api/vault/vault-user-form-document-suggestion/${formId}`, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  refreshDocument(payload: any): Observable<any> {
    return this.httpService.post<any>(`api/vault/re-process`, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getUnlinkedForm(): Observable<any> {
    return this.httpService.get<any>(`api/vault/unlinked-mx-forms`, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getVaultSuggestionCountByType(type?: String, vaultId?: string): Observable<any> {
    let url = `api/vault/suggestions-type-count`
    if(type) {
      url = `${url}/${type}`
    }
    if(vaultId) {
      url = `${url}?vaultid=${vaultId}`
    }
    return this.httpService.get<any>(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getVaultSuggestionByType(type : String = '', vaultId?: string): Observable<any> {
    let url = `api/vault/suggestions-type`
    if(type) {
      url = `${url}/${type}`
    }
    if(vaultId) {
      url = `${url}?vaultid=${vaultId}`
    }
    return this.httpService.get<any>(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
}

interface data {
  user_id: number;
  name: string;
  member: Array<{
    user_id: number;
    name: string;
    type: 'owner' | 'member';
  }>;
}
